import { animate, useInView } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

export function useCountUp(end: number, duration = 2) {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return;

    const controls = animate(0, end, {
      duration,
      ease: 'easeOut',
      onUpdate(value) {
        setCount(Math.round(value));
      },
    });

    return controls.stop;
  }, [isInView, end, duration]);

  return { ref, count };
}
